const dictionary: Record<string, string> = {
  id: "ID",
  userName: "ユーザー名",
  email: "メールアドレス",
  password: "パスワード",
  memberNumber: "会員管理番号",
  applicantName: "代表者名",
  applicantNameKana: "代表者フリガナ",
  birthDate: "生年月日",
  age: "年齢",
  homePostalCode: "自宅郵便番号",
  homePrefecture: "自宅都道府県",
  homeCity: "自宅市区町村",
  homeAddress1: "自宅番地",
  homeAddress2: "自宅建物名／号室",
  homePhoneNumber: "自宅電話番号",
  mobileNumber: "携帯番号",
  invoiceNumber: "インボイス番号",
  companyName: "会社名",
  corporateNumber: "法人番号",
  postalCode: "会社郵便番号",
  prefecture: "会社都道府県",
  city: "会社市区町村",
  address1: "会社番地",
  address2: "会社建物名／号室",
  phoneNumber: "会社電話番号",
  faxNumber: "FAX 番号",
  industryType: "業種",
  annualSales: "年商",
  employeeCount: "従業員数",
  taxDelayType: "税金滞納の種類",
  taxDelayBalance: "滞納残高",
  taxDelayStatus: "滞納状況",
  familyStructure: "家族構成",
  relationship: "続柄",
  fullName: "氏名",
  contactInfo: "連絡先",
  factoringHistory: "ファクタリング利用歴",
  pastProviders: "過去利用業者名",
  pastProviderAmount: "過去利用金額",
  currentProviderHistory: "現在利用ファクタリング業者",
  currentProviders: "現在利用業者名",
  currentProviderAmount: "現在利用金額",
  personalInfoConsent: "個人情報登録の同意",
  amount: "金額",
  images: "画像",
  isApproved: "本会員か",
  isDetailRegistered: "詳細登録完了か",
  registeredAt: "登録日",
  approvedAt: "承認日",
  createdAt: "作成日",
  updatedAt: "更新日",
};

export function getJaDisplayName(varName: string): string {
  return dictionary[varName] || varName;
}

export function getApprovalDisplayName(isApproved: boolean): string {
  if (isApproved) {
    return "本会員"
  }

  return "仮会員"
}
